module.exports = __webpack_public_path__ + "img/ic-bebe.5fb7108e.svg";